export const common = {
    "videoEmbeder": {
        "consentRequired": "To view this YouTube video, please accept cookies.",
        "acceptButton": "Accept YouTube Cookies",
        "noVideo": "No video available."
    },
    "pricing": {
        "title": "Choose your plan",
        "subTitle": "Flexible plans for any team size",
        "monthly": "Monthly",
        "yearly": "Yearly",
        "customPrice": "Custom Pricing"
    },
    "personal": {
        "title": "Personal Use",
        "description": "Basic email security tools for one domain",
        "tooltip": "Perfect for individuals managing 1 domain.",
        "cta": "Get Started"
    },
    "smb": {
        "title": "SMB Plan",
        "description": "Advanced tools for growing companies",
        "tooltip": "Up to 5 domains and 100 DMARC reports/month",
        "cta": "Select Plan"
    },
    "enterprise": {
        "title": "Enterprise",
        "description": "Tailored enterprise solution",
        "tooltip": "Unlimited domains, users, and full SLA support.",
        "cta": "Get in Touch",
        "badge": "Best Value",
        customPrice: "Get in Touch for a Price fitting your business"
    },
    "setupService": {
        "title": "Need help setting up DMARC, SPF, and DKIM?",
        "description": "Book a one-time setup call with our experts.",
        "cta": "Book Setup Service"
    },
    termsAndConditions: {
        agree: "I agree to the <a>terms and conditions</a>"
    },
    "registerModal": {
        "title": "Start your subscription",
        "subtitle": "Secure checkout in the next step",
        "emailLabel": "Email address",
        "note": "After entering your email, you'll be redirected to our secure payment partner",
        "ctaNote": "to complete your subscription. No account needed yet.",
        "cancel": "Cancel",
        "submit": "Continue to Payment",
        "errors": {
            "exists": "This email is already registered. Try logging in instead.",
            "invalid": "Please enter a valid email address.",
            "generic": "Something went wrong. Please try again later."
        },
        "loginLink": "Go to login →"
    }
}